module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade select-date-modal",
    attrs: {
      "id": "show-image-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-lg"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('closeImageModal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mb-15"
  }, [_c('img', {
    attrs: {
      "src": _vm.file.name,
      "width": "100%",
      "id": "modal-image",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer d-flex justify-content-center mt-20"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('closeImageModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.close")) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadCheckListFile($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("button.download")) + "\n          ")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30989f35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/bookings/details/modals/ViewCheckListMultimedia.vue
// module id = 1358
// module chunks = 0